import React, { useState } from "react";
import PropTypes from "prop-types";
import { Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import YouTubeIcon from "@mui/icons-material/YouTube";

function EntityHeader({ profileObject, entityObject }) {
    const [expanded, setExpanded] = useState(false);
    const isYouTube = entityObject.platform === "YouTube" ||
        !!entityObject.videoId ||
        (entityObject.permalink && entityObject.permalink.includes("youtube"));

    const renderPlatformIcon = (platform) => {
        if (platform === "Facebook") return <FacebookRoundedIcon fontSize="small" />;
        if (isYouTube) return <YouTubeIcon fontSize="small" />;
        return null;
    };

    return (
        <MDBox sx={{ flex: "0 0 auto", mb: 2 }}>
            <MDBox display="flex" alignItems="center" gap={1} mb={1}>
                {renderPlatformIcon(entityObject.platform)}
                <MDTypography variant="h6">
                    {profileObject?.name}
                </MDTypography>
            </MDBox>

            {/* Text Content Container */}
            <MDBox
                sx={{
                    mb: 1,
                    pr: 1,
                }}
            >
                <MDTypography variant="body2" color="text">
                    {(() => {
                        const text = entityObject.message || entityObject.title || entityObject.caption || "";
                        const limit = 180; // Character limit before truncation

                        if (text.length <= limit) {
                            return text;
                        }

                        if (expanded) {
                            return (
                                <>
                                    {text}{" "}
                                    <MDTypography
                                        component="span"
                                        variant="button"
                                        fontWeight="bold"
                                        color="info"
                                        sx={{ textDecoration: "underline", cursor: "pointer" }}
                                        onClick={() => setExpanded(false)}
                                    >
                                        See less
                                    </MDTypography>
                                </>
                            );
                        }

                        // Truncated View
                        return (
                            <>
                                {text.slice(0, limit)}...{" "}
                                <MDTypography
                                    component="span"
                                    variant="button"
                                    fontWeight="bold"
                                    color="info"
                                    sx={{ textDecoration: "underline", cursor: "pointer" }}
                                    onClick={() => setExpanded(true)}
                                >
                                    See more
                                </MDTypography>
                            </>
                        );
                    })()}
                </MDTypography>
            </MDBox>

            <MDBox display="flex" alignItems="center" gap={1}>
                <OpenInNewIcon fontSize="small" color="info" />
                <MDTypography variant="button" color="info">
                    <a
                        href={entityObject.permalink || entityObject.permalink_url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {isYouTube ? "View Video" : "View post"}
                    </a>
                </MDTypography>
            </MDBox>
        </MDBox>
    );
}

EntityHeader.propTypes = {
    profileObject: PropTypes.object,
    entityObject: PropTypes.object.isRequired,
};

export default EntityHeader;
